<script>
import LoginFormItemInput from './LoginFormItemInput.vue'
import LoginFormLoginMethod from '@/views/login/components/LoginFormLoginMethod.vue'
import LoginFormInputPhone from '@/views/login/components/LoginFormInputPhone.vue'
import LoginFormItemInputAccount from '@/views/login/components/LoginFormItemInputAccount.vue'
import { formatPhoneNumber } from '@/utils/format'

export default {
  name: 'LoginFormInput',
  components: {
    LoginFormItemInputAccount,
    LoginFormInputPhone,
    LoginFormLoginMethod,
    LoginFormItemInput,
  },
  props: {
    id: {
      type: String,
      default: '',
    },
    name: {
      type: String,
      default: '',
    },
    email: {
      type: String,
      default: '',
    },
    password: {
      type: String,
      default: '',
    },
    phoneNumber: {
      type: String,
      default: '',
    },
    countryCallingCode: {
      type: String,
      default: '',
    },
    loginMethod: {
      type: String,
      default: 'email',
    },
    verifyingPassword: {
      type: Boolean,
      default: false,
    },
    submitting: {
      type: Boolean,
      default: false,
    },
    errorMessages: {
      type: Object,
      default: () => ({
        email: '',
        password: '',
      }),
    },
  },
  emits: [
    'update:email',
    'update:password',
    'update:phone-number',
    'update:country-calling-code',
    'blur:email',
    'blur:password',
    'blur:phone-number',
    'update:login-method',
    'click:change',
    'click:forgot-password',
  ],
  data() {
    return {
      passwordType: 'password',
    }
  },
  computed: {
    eyeIcon() {
      return this.passwordType === 'password' ? 'eye' : 'eye-open'
    },
    accountInfoText() {
      if (this.loginMethod === 'email') {
        return this.email
      }

      return formatPhoneNumber(this.countryCallingCode, this.phoneNumber)
    },
  },
  methods: {
    // TODO: Duplicated code, will refactor to composition API in Vue3
    togglePasswordType(event) {
      event.stopPropagation()

      this.passwordType = this.passwordType === 'password' ? 'text' : 'password'
    },
  },
}
</script>

<template>
  <div class="tamara-login-body__form">
    <Transition mode="out-in" name="fade">
      <LoginFormItemInputAccount
        v-if="verifyingPassword"
        :value="accountInfoText"
        :login-method="loginMethod"
        @click:change="$emit('click:change')"
      />
      <LoginFormLoginMethod
        v-else
        :value="loginMethod"
        @update:value="$emit('update:login-method', $event)"
        @click:phone-numer-tab="$emit('click:phone-numer-tab')"
      />
    </Transition>

    <div class="tamara-login-body__form-container">
      <LoginFormItemInput
        v-if="loginMethod === 'email' && !verifyingPassword"
        id="email"
        :value="email"
        :label="$t('login_email_label')"
        type="email"
        name="email"
        :placeholder="$t('email_placeholder')"
        :error-message="errorMessages.email"
        :disabled="submitting"
        @blur="$emit('blur:email')"
        @input="$emit('update:email', $event)"
        @enter="$emit('enter:email', $event)"
      />
      <LoginFormInputPhone
        v-else-if="!verifyingPassword"
        name="phoneNumber"
        :phone-number="phoneNumber"
        :country-calling-code="countryCallingCode"
        :error-message="errorMessages.phoneNumber"
        :disabled="submitting"
        @blur="$emit('blur:phone-number')"
        @enter="$emit('enter:phone', $event)"
        @update:phone-number="$emit('update:phone-number', $event)"
        @update:country-calling-code="
          $emit('update:country-calling-code', $event)
        "
      />
      <!-- We have to use the v-show to help browser to autocomplete the form fields -->
      <div
        v-show="verifyingPassword"
        class="tamara-login-body__form-item password-input"
      >
        <LoginFormItemInput
          id="password"
          name="password"
          :value="password"
          :label="$t('login_password_label')"
          :type="passwordType"
          :placeholder="$t('password_placeholder')"
          :error-message="errorMessages.password"
          :disabled="submitting"
          @blur="$emit('blur:password')"
          @input="$emit('update:password', $event)"
          @enter="$emit('enter:password', $event)"
        >
          <svg-icon
            slot="suffix"
            :icon-class="eyeIcon"
            height="24px"
            width="24px"
            @click.stop="togglePasswordType"
          />
        </LoginFormItemInput>
        <div class="mt-3 tamara-login-body__form-item-forgot-password">
          <el-link class="forgot-link" @click="$emit('click:forgot-password')">
            {{ $t('forgot_password_link') }}
          </el-link>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import '@/styles/lavender/design.scss';

.tamara-login-body__form {
  display: flex;
  flex-direction: column;
  gap: 32px;

  &-item {
    &.password-input {
      ::v-deep {
        .el-input__suffix {
          right: 16px;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          width: 32px;
          padding: 0;

          .el-input__suffix-inner {
            cursor: pointer;
          }

          [dir='rtl'] & {
            right: unset;
            left: 16px;
          }
        }
      }
    }

    &-forgot-password {
      @extend .tamara-label-regular-3;

      color: rgba(95, 101, 135, 0.5);
      text-align: end;
    }
  }
}
</style>
